import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPlaylistAddCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={10}
    fill="currentColor"
    viewBox="0 0 15 10"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.756 7.75a.74.74 0 0 1-.537-.214A.71.71 0 0 1 0 7.004q0-.316.215-.535A.72.72 0 0 1 .75 6.25h4.495q.318 0 .537.214T6 6.996t-.215.535a.72.72 0 0 1-.534.219zm0-3.125a.74.74 0 0 1-.537-.214A.71.71 0 0 1 0 3.879q0-.316.215-.535a.72.72 0 0 1 .534-.219h7.495q.318 0 .537.214T9 3.871t-.215.535a.72.72 0 0 1-.534.219zm0-3.125a.74.74 0 0 1-.537-.214A.71.71 0 0 1 0 .754Q0 .438.215.22A.72.72 0 0 1 .75 0h7.495q.318 0 .537.214T9 .746t-.215.535a.72.72 0 0 1-.534.219zm9.81 8.313q-.15 0-.295-.063a.8.8 0 0 1-.25-.167L8.104 7.687a.72.72 0 0 1-.229-.52q0-.292.23-.521a.73.73 0 0 1 1.062 0l1.229 1.229 3.02-3.02a.68.68 0 0 1 .521-.22.8.8 0 0 1 .531.24.745.745 0 0 1-.01 1.063l-3.375 3.625q-.105.104-.235.177a.6.6 0 0 1-.281.072"
    />
  </svg>
);
export default SvgPlaylistAddCheck;
